import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UtilitiesService } from '../../services/utilities/utilities.service';
import { NgoCampaignService } from '../../services/ngo-campaign/ngo-campaign.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';

@Component({
  selector: 'app-sliding-campaign-cards',
  templateUrl: './sliding-campaign-cards.component.html',
  styleUrl: './sliding-campaign-cards.component.scss',
})
export class SlidingCampaignCardsComponent {
  @Input() featuredCampaigns: any[] = [];
  public groupedCampaigns: any[][] = [];

  public handlingLessThanThreeCampaigns: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly utilitiesService: UtilitiesService,
    private readonly campaignService: NgoCampaignService,
    private readonly localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    // this.campaignService.getFeaturedNgoDonationCampaign().subscribe({
    //   next: (result) => {
    //     this.featuredCampaigns = result;
    //     this.groupedCampaigns = this.chunkArray(this.featuredCampaigns, 2);
    //   },
    // });
    if (this.featuredCampaigns.length > 0) {
      this.groupedCampaigns = this.chunkArray(this.featuredCampaigns, 2);
      // this.handlingLessThanThreeCampaigns = this.featuredCampaigns.length < 3;
    }
    console.log(this.featuredCampaigns);
  }

  public chunkArray(array: any[], size: number): any[][] {
    const chunkedArr = [];
    for (let i = 0; i < array.length; i += size) {
      chunkedArr.push(array.slice(i, i + size));
    }
    return chunkedArr;
  }

  public navigateToCampaign(campaign: any) {
    const encryptedParams = this.localStorageService.encryptObjectUrl({
      ngo_id: campaign?.ngo_id,
      project_id: campaign?.project_id,
      id: campaign?.id,
    });
    this.router.navigate(['/campaign'], {
      queryParams: { data: encryptedParams },
    });
  }
}
